import { Space } from "components/Common/Space";
import { ExerciseHeader } from "components/Common/ExerciseHeader";
import {
  useUpdateChapterStudentProgress,
  useUpdateHomeworkStudentProgress,
} from "hooks/api/student-progress";
import { useRole } from "hooks/common";
import { useParams } from "react-router-dom";
import { TestQuestionList } from "./TestQuestionList";
import { TTestExercise, TTestExercisePayload } from "types/app/exercises";
import "./TestExercise.styles.scss";

type TTestExerciseProps = {
  /**
   * Chapter ID to which the exercise belongs.
   */
  chapterId: number;
  /**
   * An exercise raw data from API response.
   */
  exercise: TTestExercise;
  /**
   * Lesson chapter order number with the exercise sequence number to display before the exercise condition.
   * @default null
   */
  prefix?: string | null;
  /**
   * Whether it’s a homework exercise.
   */
  isHomeworkExercise: boolean;
};

export const TestExercise: React.FC<TTestExerciseProps> = (props) => {
  const { chapterId, exercise, prefix, isHomeworkExercise } = props;

  const { courseId, lessonId, studentId } = useParams();
  const { isUserStudent } = useRole();

  const { mutate: updateChapterProgress } = useUpdateChapterStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );
  const { mutate: updateHomeworkProgress } = useUpdateHomeworkStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );

  const handleUpdateExercise = (updatedExercise: TTestExercise) => {
    if (!isUserStudent || !studentId) return;

    if (isHomeworkExercise) {
      updateHomeworkProgress(updatedExercise);
    } else {
      updateChapterProgress(updatedExercise);
    }
  };

  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      <ExerciseHeader<TTestExercisePayload>
        chapterId={chapterId}
        exercise={exercise}
        prefix={prefix}
      />
      <TestQuestionList
        questions={exercise.payload.data.questions}
        exercise={exercise}
        chapterId={chapterId}
        isHomeworkExercise={isHomeworkExercise}
        onUpdateExercise={handleUpdateExercise}
      />
    </Space>
  );
};
